import { IUser } from "app/interfaces/user/user.interface";

const LocalStorageService = {
    getUserData(): IUser {
        return JSON.parse(localStorage.getItem('user') as string);
    },
    getToken(): string {
        const userData = this.getUserData();
        return userData ? userData.token : '';
    },
    isLoggedIn(): boolean {
        return !!this.getToken();
    },
    clearData(): void {
        localStorage.clear();
    },
    getUsername(): string {
        const userData = this.getUserData();
        return userData ? userData.userName : '';
    },
};

export default LocalStorageService;
